import React, {useMemo} from "react";

import { Chart } from "react-charts";

export default function MonthlyCountChart({sequences}){

  const primaryAxis = React.useMemo(
    () => ({
      getValue: datum => datum.month,
    }),
    []
  )

  const secondaryAxes = React.useMemo(
    () => [
      {
        getValue: datum => datum.count,
      },
    ],
    []
  )

  const data = useMemo(() => [
    {
      label: 'Articles per Month',
      data: sequences
    },
  ], [sequences])

    return(
      <Chart
        style={{marginLeft:10, marginRight:20}}
        options={{
          data,
          primaryAxis,
          secondaryAxes,
          defaultColors:['#6415ff']
        }}
      />
  )
}